import React from "react";
import { ThemeProvider } from "styled-components";

import Peracto from "@peracto/peracto";
import Config from "@peracto/peracto-config";
import PeractoUser from "@peracto/peracto-user";
import PeractoCommon from "@peracto/peracto-common";
import PeractoContent from "@peracto/peracto-content";

import * as buttonVariants from "./Inputs/Button/variants";

import { EditorTheme, AdminTheme, GlobalStyles } from "./theme";
import {
    Checkbox,
    CheckboxGroup,
    Input,
    Radio,
    Select,
    Textarea,
    Button,
} from "./Inputs";

import blocks from "./blocks";
import { menu } from "./menu";
import compact from "lodash/compact";
import startCase from "lodash/startCase";

const config = new Config({
    api: process.env.REACT_APP_API,
    algolia: {
        applicationId: process.env.REACT_APP_ALGOLIA_APPLICATION_ID,
        searchApiKey: process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY,
        indexName: process.env.REACT_APP_ALGOLIA_INDEX_NAME,
    },
    modules: [PeractoUser(), PeractoCommon(), PeractoContent()],
    editorConfig: {
        theme: EditorTheme,
        colorOptions: compact(
            Object.entries(EditorTheme.colors.brand).map(([label, value]) => {
                return { label: startCase(label), value };
            })
        ),
        buttonVariants,
        headings: [
            {
                model: "hugeHeading2",
                title: "Huge Heading 2",
                class: "ck-heading_heading1",
                view: {
                    name: "h2",
                    classes: "heading2-huge",
                },
                converterPriority: "high",
            },
            {
                model: "heading2Line",
                title: "Heading 2 with Line",
                class: "ck-heading_heading1",
                view: {
                    name: "h2",
                    classes: "heading2-line",
                },
                converterPriority: "high",
            },
        ],
        locales: ["en_GB"],
        blocks,
        inputTypes: {
            Checkbox,
            CheckboxGroup,
            Input,
            Radio,
            Select,
            Textarea,
            Button,
        },
        stylesheets: ["https://use.typekit.net/xbj2sbo.css"],
        globalStyles: GlobalStyles,
    },
    features: {
        dashboard: {
            tables: true,
        },
        shippingServices: {
            deliveryDays: true,
            conditions: true,
        },
        products: {
            exportProductData: true,
            productVariants: true,
        },
        content: {
            indexContent: true,
            searchableFalseOnCreation: true,
        },
    },
    menu,
});

const App = () => (
    <ThemeProvider theme={AdminTheme}>
        <Peracto config={config} />
    </ThemeProvider>
);

export default App;
